import { apiGet } from './api';

export type CourseSessionRow = {
  _id: string;
  date?: string;
  sessionType?: string;
  duration?: number;
  attendanceStatus?: string;
  status?: string;
  location?: string;
  teacherNotes?: string;
  studentNotes?: string;
  sessionNumber?: number;
  userId?: string | { _id?: string; nickname?: string; email?: string };
  profId?: string | { _id?: string; nickname?: string; email?: string };
};

export async function getStudentSessions(userId: string, limit = 50) {
  const res = await apiGet<{
    success: boolean;
    data?: {
      sessions: CourseSessionRow[];
      pagination?: { total: number; page: number; limit: number };
    };
  }>(`/api/v1/course-sessions/student/${userId}?limit=${limit}&page=1`);
  return res;
}
